/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { CaneCleaning } from "./modelCaneCleaning";

class ControllerCaneCleaning extends ControllerModel {
  constructor() {
    super("ControllerCaneCleaning");

    this.setNewNode = (callback) => {
      let caneCleaning = new CaneCleaning();
      caneCleaning.decorate(callback);

      this.addNode(caneCleaning);
      SingletonFlowchart.SaveStatus();
    };

    this.loadNode = (node, callback) => {
      let caneCleaning = new CaneCleaning();
      caneCleaning.copyFrom(node);
      caneCleaning.decorate(callback);
      this.addNode(caneCleaning);
    };

    this.getProperties = async (node) => {
      let n = new CaneCleaning();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new CaneCleaning();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerCaneCleaning };
